module.exports = __webpack_public_path__ + "img/20190708164141QQ截图20190708030057.620cd768.png";